import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate"; // https://baianat.github.io/vee-validate/
import VueLogger from "vuejs-logger"; // https://www.npmjs.com/package/vuejs-logger

import { store } from "./store";
import { router } from "./helpers";
import App from "./App";

import "@mdi/font/css/materialdesignicons.css"; // npm install @mdi/font -D
import SvgPathIcon from "./components/common/SvgPathIcon.vue";

import Vuetify from "vuetify";
import DatePicker from "@/components/DatePicker.vue";
import ListaBusqueda from "@/components/common/ListaDeBusqueda.vue";
import ListaDoble from "@/components/common/ListaDoble.vue";
import DomicilioSimple from "@/components/DomicilioSimple.vue";
import DomicilioCompleto from "@/components/common/DomicilioCompleto.vue";
import DomicilioEditor from "@/components/common/DomicilioEditor.vue";
import TelefonoCompleto from "@/components/common/TelefonoCompleto.vue";
import TelefonoEditor from "@/components/common/TelefonoEditor.vue";
import CuentaBancoCompleto from "@/components/common/CuentaBancoCompleto.vue";
import TarjetaCompleto from "@/components/common/TarjetaCompleto.vue";
import EmpleoEditor from "@/components/legajo/empleoeditor.vue";
import EmpleoCompleto from "@/components/legajo/empleocompleto.vue";
import ManejoDomicilios from "@/components/common/ManejoDomicilios.vue";
import ManejoTelefonos from "@/components/common/ManejoTelefonos.vue";
import ManejoEmpleos from "@/components/legajo/manejoempleos.vue";
import ManejoCuentasBanco from "@/components/common/ManejoCuentasBanco.vue";
import BusquedaPersona from "@/components/BusquedaPersona.vue";
import BusquedaPersonas from "@/components/common/BusquedaPersonas.vue";
import UserCustomization from "@/components/config/usercustomization.vue";
import AmbienteCustomization from "@/components/config/ambiente.vue";
import ListaTasas from "@/components/ListaTasas.vue";
import ListaCargos from "@/components/ListaCargos.vue";
import ListaCanalesVenta from "@/components/ListaCanalesVenta.vue";
import Loading from "@/components/common/Loading.vue";
import SelectorPeriodos from "@/components/SelectorPeriodos.vue";
import ValidadorPolitica from "@/components/creditos/ValidadorPoliticaComercial.vue";
import Autorizador from "@/components/common/Autorizador.vue";
import ModificadorPlanCredito from "@/components/creditos/ModificacionPlanCredito.vue";
import ModificadorCanalVenta from "@/components/creditos/ModificacionCanalVenta.vue";
import ListaCreditos from "@/components/creditos/ListaCreditos.vue";
import ResumenEjecutivo from "@/components/creditos/ResumenEjecutivo.vue";
import DatosDebitoCredito from "@/components/creditos/DatosDebito.vue";
import InfoConsultaMotorSiisa from "@/components/creditos/InfoConsultaMotorSiisa.vue";
import FechaDesdeHasta from "@/components/FechaDesdeHasta.vue";
import CreditosParaRefinanciarORenovar from "@/components/creditos/CreditosParaRefinanciarORenovar.vue";
import ListaLogAccionesCredito from "@/components/creditos/ListaLogAcciones.vue";
import GestionCasoPuntual from "@/components/gestion/AltaGestionPuntual.vue";
import ContactosPersona from "@/components/gestion/ContactosPersona2.vue";

import Alertas from "@/components/common/Alertas.vue";
import DatosTarjeta from "@/components/creditos/DatosTarjeta.vue";
import DatosTarjetaTokenizada from "@/components/common/ManejoTarjetas.vue";
//import FormularioTarjeta from '@/components/coin/FormularioTarjeta.vue'
import FormularioTarjetaCoin from "@/components/coin/FormularioPago.vue";

import LogContactosPersona from "@/components/gestion/ContactosPersona2.vue";
import LogLegajoDigital from "@/components/creditos/LogLegajoDigital.vue";
import LogLegajoFisico from "@/components/creditos/LogLegajoFisico.vue";
import LogProductoDirigido from "@/components/creditos/LogEstadoProductoDirigido.vue";

import PagoOnLine from "@/components/creditos/PagoOnLine.vue";

import VariablesMotor from "@/components/creditos/VariablesMotorSiisa.vue";
import ResultadosEnvioDebito from "@/components/debitos/resultadosEnvios.vue";

import DatosAdicionalesCredito from "@/components/creditos/DatosAdicionales.vue";
import ConfirmarCobranza from "@/components/caja/confirmarcobranza.vue";
import ConfirmarEgreso from "@/components/caja/confirmaregreso.vue";

import ConfiguracionTickeadora from "@/components/config/configuraciontickeadora.vue";

import AltaMovimientoPuntualCaja from "@/components/caja/altamovimiento.vue";
import CierreCaja from "@/components/caja/cierre.vue";
import AnularMovimientoCaja from "@/components/caja/anulacion.vue";
import ListadosCaja from "@/components/caja/listados.vue";

import AccionesComunes from "@/components/common/AccionesComunes.vue";

import AltaQuitas from "@/components/comprobantes/AltaQuitas.vue";
import AltaCargos from "@/components/comprobantes/AltaCargos.vue";
import AltaNotasCreditoFiscales from "@/components/comprobantes/AltaNotasCreditoFiscales.vue";
import AltaNotasDebitoFiscales from "@/components/comprobantes/AltaFacturasNotasDebitoFiscales.vue";
import ImpresionComprobantes from "@/components/comprobantes/ImpresionComprobantes.vue";

import ImpresionFormularios from "@/components/creditos/ImpresionFormularios.vue";

import AltaAcuerdo from "@/components/creditos/AltaAcuerdo.vue";

import AltaModificacionProspecto from "@/components/prospectos/AltaModificacionProspecto.vue";
import AltaConsulta from "@/components/consultas/AltaConsulta.vue";

import AltaVentaCartera from "@/components/ventacartera/AltaVentaCartera.vue";

import ModificacionVencimientos from "@/components/creditos/ModificacionVencimientos.vue";

import ReportesTest from "@/components/reporting/ReportViewerTest.vue";
import ReportViewer from "@/components/reporting/ReportViewer.vue";
import ReporteCuotasPorPlan from "@/components/reporting/cuotasPorPlan.vue";

import LinkGueno from "@/components/common/LinkGueno.vue";
import LinkDigiventures from "@/components/common/LinkDigiventures.vue";
import LinkCardCred from "@/components/common/LinkCardCred.vue";
import LinkCargaRapidaComer from "@/components/cargarapidacomer/LinkCargaRapidaComer.vue";

import ModificarReclamo from "@/components/gestion/ModificaReclamo.vue";
import AltaReclamo from "@/components/gestion/AltaReclamo.vue";
import AltaDenuncia from "@/components/gestion/AltaDenuncia.vue";
import ModificarDenuncia from "@/components/gestion/ModificarDenuncia.vue";

import PagoTarjeta from "@/components/mediosPago/PagoTarjeta.vue";

import es from "vee-validate/dist/locale/es";

import VuetifyDialog from "vuetify-dialog"; // https://www.npmjs.com/package/vuetify-dialog
import "vuetify-dialog/dist/vuetify-dialog.css";

import "vuetify/dist/vuetify.min.css";

import ManejoFechasCobro from "@/components/backoffice/manejoFechasCobro.vue";

/* -- UPDATE ALL PACKAGES
npm i -g npm-check-updates
npm-check-updates -u
npm install
*/

// Global components
Vue.component("svg-path-icon", SvgPathIcon);
Vue.component("app-loading", Loading);
Vue.component("app-date-picker", DatePicker);
Vue.component("app-lista-busqueda", ListaBusqueda);
Vue.component("app-acciones-comunes", AccionesComunes);
Vue.component("app-user-customization", UserCustomization);
Vue.component("app-ambiente-customization", AmbienteCustomization);
Vue.component("app-lista-doble", ListaDoble);
Vue.component("app-domicilio-simple", DomicilioSimple);
Vue.component("app-domicilio-completo", DomicilioCompleto);
Vue.component("app-domicilio-editor", DomicilioEditor);
Vue.component("app-telefono-completo", TelefonoCompleto);
Vue.component("app-telefono-editor", TelefonoEditor);
Vue.component("app-cuenta-banco-completo", CuentaBancoCompleto);
Vue.component("app-tarjeta-completo", TarjetaCompleto);
Vue.component("app-empleo-editor", EmpleoEditor);
Vue.component("app-empleo-completo", EmpleoCompleto);
Vue.component("app-manejo-cuentas-banco", ManejoCuentasBanco);
Vue.component("app-manejo-domicilios", ManejoDomicilios);
Vue.component("app-manejo-telefonos", ManejoTelefonos);
Vue.component("app-manejo-empleos", ManejoEmpleos);
Vue.component("app-busqueda-persona", BusquedaPersona);
Vue.component("app-busqueda-personas", BusquedaPersonas); // control con busqueda x distintos criterios (nombre, documento, cuil, operación)
Vue.component("app-lista-tasas", ListaTasas);
Vue.component("app-lista-cargos", ListaCargos);
Vue.component("app-lista-canalesventa", ListaCanalesVenta);
Vue.component("app-lista-log-acciones-credito", ListaLogAccionesCredito);
Vue.component("app-validador-politica-comercial", ValidadorPolitica);
Vue.component("app-selector-periodos", SelectorPeriodos);
Vue.component("app-autorizador", Autorizador);
Vue.component("app-modificador-plan-credito", ModificadorPlanCredito);
Vue.component("app-modificador-canalventa-credito", ModificadorCanalVenta);
Vue.component("app-lista-creditos", ListaCreditos);
Vue.component("app-resumen-ejecutivo", ResumenEjecutivo);
Vue.component("app-fecha-desdehasta", FechaDesdeHasta);

Vue.component("app-datos-debito-credito", DatosDebitoCredito);
Vue.component("app-info-consulta-motor-siisa", InfoConsultaMotorSiisa);
Vue.component(
  "app-creditos-para-refinanciar-renovar",
  CreditosParaRefinanciarORenovar,
);
Vue.component("gestion-caso-puntual", GestionCasoPuntual);
Vue.component("app-log-legajo-digital", LogLegajoDigital);
Vue.component("app-log-legajo-fisico", LogLegajoFisico);
Vue.component("app-log-producto-dirigido", LogProductoDirigido);
Vue.component("app-log-contactos", LogContactosPersona);
Vue.component("app-datos-tarjeta", DatosTarjeta);
Vue.component("app-datos-tarjeta-tokenizada", DatosTarjetaTokenizada);
//Vue.component('app-tarjeta-credito-completo', FormularioTarjeta)
Vue.component("app-formulario-tarjeta-coin", FormularioTarjetaCoin);
Vue.component("app-pago-on-line", PagoOnLine);

Vue.component("app-variables-motor", VariablesMotor);
Vue.component("app-datos-adicionales-credito", DatosAdicionalesCredito);

Vue.component("app-confirmar-cobranza", ConfirmarCobranza);
Vue.component("app-confirmar-egreso", ConfirmarEgreso);

Vue.component("app-configuracion-tickeadora", ConfiguracionTickeadora);

Vue.component("app-alta-movimiento-puntual-caja", AltaMovimientoPuntualCaja);
Vue.component("app-cierre-caja", CierreCaja);
Vue.component("app-anular-movimiento-caja", AnularMovimientoCaja);
Vue.component("app-listados-caja", ListadosCaja);

Vue.component("app-contactos-persona", ContactosPersona);

Vue.component("app-alta-quitas", AltaQuitas);
Vue.component("app-alta-cargos", AltaCargos);
Vue.component("app-alta-notas-credito-fiscales", AltaNotasCreditoFiscales);
Vue.component("app-alta-notas-debito-fiscales", AltaNotasDebitoFiscales);

Vue.component("app-impresion-comprobante", ImpresionComprobantes);

Vue.component("app-alta-acuerdo", AltaAcuerdo);

Vue.component("app-resultados-envio-debito", ResultadosEnvioDebito);

Vue.component("app-impresion-formulario", ImpresionFormularios);

Vue.component("reportes-test", ReportesTest);
Vue.component("reportes-viewer", ReportViewer);
Vue.component("reporte-cuotas-por-plan", ReporteCuotasPorPlan);

Vue.component("alta-modificacion-prospecto", AltaModificacionProspecto);
Vue.component("alta-consulta", AltaConsulta);

Vue.component("alta-venta-cartera", AltaVentaCartera);

Vue.component("app-modificacion-vencimientos", ModificacionVencimientos);
Vue.component("app-alertas", Alertas);
Vue.component("app-link-gueno", LinkGueno);
Vue.component("app-link-digiventures", LinkDigiventures);
Vue.component("app-link-cardcred", LinkCardCred);
Vue.component("app-link-carga-rapida-comer", LinkCargaRapidaComer);

Vue.component("app-alta-reclamo", AltaReclamo);
Vue.component("app-modifica-reclamo", ModificarReclamo);

Vue.component("app-pagoonline-tarjeta", PagoTarjeta);

Vue.component("app-alta-denuncia", AltaDenuncia);
Vue.component("app-modifica-denuncia", ModificarDenuncia);
Vue.component("manejo-fechas-cobro", ManejoFechasCobro);
//

// filtros globales
import VueCurrencyFilter from "vue-currency-filter"; // https://github.com/mazipan/vue-currency-filter
Vue.use(VueCurrencyFilter, {
  symbol: "$",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "front",
  symbolSpacing: true,
});

import VueFilterDateParse from "vue-filter-date-parse";
Vue.use(VueFilterDateParse);

import VueFilterDateFormat from "vue-filter-date-format"; // https://github.com/eduardnikolenko/vue-filter-date-format

Vue.use(VueFilterDateFormat, {
  dayOfWeekNames: [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ],
  dayOfWeekNamesShort: ["Do", "Lu", "Ma", "Mi", "Ju", "FVi", "Sa"],
  monthNames: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  monthNamesShort: [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ],
});

// end filtros globales

Vue.use(Vuetify);

//  Vue.use(Vuetify, {
//   theme: {
//     dark: true,
//     primary: colors.orange,
//     secondary: colors.grey.darken1,
//     accent: colors.shades.black,
//     error: colors.red
//   }
// });

Vue.use(require("vue-moment")); // https://github.com/brockpetrie/vue-moment

Vue.use(VeeValidate);
Validator.localize("es", es);

Vue.config.productionTip = false;

// logger
const isProduction = process.env.NODE_ENV === "production";

const options = {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
  icons: {
    iconfont: "mdi", // default - only for display purposes
  },
};

Vue.use(VueLogger, options);

Vue.directive("uppercase", {
  update(el) {
    var inputElement = el.getElementsByTagName("input");

    if (inputElement) {
      Vue.$log.debug(inputElement[0]);
      Vue.$log.debug(inputElement[0].value);
      inputElement[0].value = inputElement[0].value.toUpperCase();
      Vue.$log.debug(inputElement[0].value);
    }
  },
});

new Vue({
  vuetify: new Vuetify(options),
  created() {
    document.addEventListener("beforeunload", this.handler);
  },
  methods: {
    handler: function handler(event) {
      event = false;
    },
  },
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

Vue.use(VuetifyDialog, {
  property: "$dialog",
});
